module.exports = __webpack_public_path__ + "static/media/Golf-Drives-Logo.0ffaba48.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Footer/images/Golf-Drives-Logo.png
// module id = 1234
// module chunks = 0